<template>
  <div class="columns is-multiline" style="padding-bottom:40px">
    <!-- 반품 정보 입력 페이지
    반품 검사중 상태인 주문 상품만 표시됩니다. -->
    <div class="column is-full">
      <admin-form-item label="반품 상품">
        <table class="delivery-orderproduct-table">
          <thead>
          <tr>
            <th style="width:35%">주문 상품</th>
            <th style="width:15%">옵션 단가</th>
            <th style="width:10%">수량</th>
            <th style="width:15%">할인 금액</th>
            <th style="width:25%">주문 상태</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(op,idx) in order_product" :key="'op-'+idx">
            <td>
              <div class="flex align-center">
                <img :src="op.product.img" style="width:35px;height:35px;margin-right:6px" v-if="op.product.img">
                <div style="text-align: left">
                  <div v-if="op.order_product_option.length>0">
                    <div>{{ op.product.name }}</div>
                    <div style="color:#C1C1C1;font-size:14px"
                         v-for="(option, option_idx) in op.order_product_option"
                         :key="'option-'+option_idx">
                      <span v-if="option.option.option_type===0">기본옵션:</span>
                      <span v-if="option.option.option_type===1">추가옵션:</span>
                      {{ option.option.name }} {{ option.option.price | currency }} X {{ option.quantity }}
                    </div>
                  </div>
                  <div v-else>
                    {{ op.product.name }} {{ op.quantity }}개
                  </div>
                </div>
              </div>

            </td>
            <td>{{ op.product_price | currency }}</td>
            <td>{{ op.quantity }}</td>
            <td>{{ op.discount_price | currency }}</td>
            <td>{{ op.status_kor }}</td>
          </tr>
          <tr style="background-color:#EBEAE4">
            <td colspan="4">총 상품 금액</td>
            <td>{{ calcTotalProductPrice | currency }}</td>
          </tr>
          </tbody>
        </table>
      </admin-form-item>
    </div>

    <div class="column is-full">
      <admin-form-item label="결제 취소/환불 금액">
        <table class="delivery-orderproduct-table">
          <thead>
          <tr>
            <th style="width:20%">항목</th>
            <th style="width:60%">내용</th>
            <th style="width:20%">환불 금액</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>상품 금액</td>
            <td style="text-align: left !important;">
              <div>주문 상품 금액: {{ calcTotalProductPrice | currency }}</div>
              <div style="margin-top:8px">
                <lp-radio :val.sync="value.refund_type"
                          value_name="value"
                          label_name="label"
                          :showInput="true"
                          :block="true"
                          @onEdit="res => inputRefundPrice(res)"
                          :data="[{label:'전액 환불', value:0},
                                  {label:'부분 환불', value:1, num: value.refund_part_price, unit:'원'}]"></lp-radio>
              </div>
            </td>
            <td>
              <!-- 마지막 환불이면서 전체 환불일 경우 -->
              <div v-if="isLastRefund && value.refund_type===0 && calcTotalProductPrice!==calcRefundTotalProductPrice"
                   class="product-price-refund-st">{{ calcTotalProductPrice | currency }}</div>
              <div v-else>{{ calcRefundProductPrice | currency }}</div>
              <div v-if="isLastRefund && value.refund_type===0 && calcTotalProductPrice!==calcRefundTotalProductPrice">남은 환불 가능한 금액{{ calcRefundTotalProductPrice | currency }}</div>
            </td>
          </tr>
          <tr>
            <td>초기 배달비</td>
            <td style="text-align: left !important;">
              <div>초기 배달비: {{ order.delivery_cost | currency }}</div>
              <div style="margin-top:8px" v-if="order.delivery_cost>0 && !isDeliveryCostRefund">
                <lp-radio :val.sync="value.is_first_dp_refund"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'환불 안 함',value:false}, {label:'환불함', value:true}]"></lp-radio>
              </div>
              <div style="margin-top:8px">* 배달비 조건 안내</div>
              <div style="white-space: pre-line;">{{ deliveryPriceInfo }}</div>
            </td>
            <td>{{ value.refund_delivery_cost | currency }}</td>
          </tr>
          <!--<tr>
            <td>반품 배달비</td>
            <td style="text-align: left !important;">
              <lp-radio :val.sync="value.dp_type"
                        value_name="value"
                        label_name="label"
                        :showInput="true"
                        :block="true"
                        @onEdit="res => inputSubstractionPrice(res)"
                        :data="[{label:'선불(구매자 부담)', value:0},
                                {label:'환불 금액에서 차감(구매자 부담)', value:1, num: value.substraction_price, unit:'원'},
                                {label:'착불(판매자 부담)', value:2}]"></lp-radio>
            </td>
            <td>-{{ value.substraction_price | currency }}</td>
          </tr>-->
          <!--<span v-if="isLastRefund">(적립금 및 쿠폰 금액에 반영)</span>-->
          <tr style="background-color:#EBEAE4">
            <td colspan="2">환불 금액 합계</td>
            <td>{{ calcTotalRefundPrice | currency }}</td>
          </tr>
          <tr v-if="order.cancel_price>0" style="background-color:#EBEAE4">
            <td colspan="2">기존 부분 환불 금액</td>
            <td>{{ order.cancel_price | currency }}</td>
          </tr>
          <tr v-if="order.cancel_price>0" style="background-color:#EBEAE4">
            <td colspan="2">예상 총 환불 금액</td>
            <td>{{ calcTotalRefundPrice + order.cancel_price | currency }}</td>
          </tr>
          <tr style="background-color:#EBEAE4">
            <td colspan="2">총 결제 금액</td>
            <td>{{ order.total_price | currency }}</td>
          </tr>
          </tbody>
        </table>
      </admin-form-item>
    </div>

    <div class="column is-full">
      <admin-form-item label="환불 방법">
        <div>
          <lp-radio :val.sync="value.refund_method"
                    value_name="value"
                    label_name="label"
                    :data="refundMethodArr"></lp-radio>
        </div>
        <div style="margin-top:6px">
          <span v-if="value.refund_method===0" class="flex">
            <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>환불 계좌로 직접 송금하는 방식입니다.</span>
          <!--          <span v-else-if="value.refund_method===1" class="flex">-->
          <!--            <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>환불 방법을 저장한 뒤, '환불 관리'에서 환불 처리해 주시기 바랍니다.</span>-->
        </div>
        <div class="columns is-multiline" style="margin-top:0" v-if="value.refund_method===0">
          <div class="column is-3">
             <span class="select">
              <select v-model="value.refund_info.bank"
                      @change="e=> value.refund_info.bank = e.target.value">
                <option value="" disabled selected>환불 계좌 선택</option>
                <option v-for="(bank, idx) in bankArr" :key="`bank-${idx}`">{{ bank.label }}</option>
              </select>
            </span>
          </div>
          <div class="column is-6">
            <input class="input"
                   :value="value.refund_info.account_num"
                   @input="e=> value.refund_info.account_num = e.target.value"
                   placeholder="계좌번호"
                   type="text">
          </div>

          <div class="column is-3">
            <input class="input"
                   :value="value.refund_info.name"
                   @input="e=> value.refund_info.name = e.target.value"
                   placeholder="계좌주"
                   type="text">
          </div>
        </div>
        <div v-if="value.refund_method===1">
          <table class="delivery-orderproduct-table" style="width:284px;">
            <thead>
            <tr>
              <th style="font-weight: 400">결제 금액</th>
              <th style="font-weight: 400">취소 금액</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ order.total_price | currency }}</td>
              <td>{{ calcTotalRefundPrice | currency }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </admin-form-item>

      <admin-form-item label="반환될 적립금 및 쿠폰" desc="마지막 환불 처리시 환불금액에 반영됩니다.">
        <div>
          <div>적립금 사용 금액: {{ order.point | currency }}</div>
          <div>쿠폰 사용 금액: {{ order.coupon_price | currency }}</div>
        </div>
      </admin-form-item>

      <!--<admin-form-item label="적립금 적용 취소" style="margin-top:20px">
        <div class="flex-align">
          <lp-check-bool :checkedVal.sync="value.is_cancel_point"
                         label="적립금"></lp-check-bool>
          <div class="flex-align" style="margin-left:8px">
            <input class="input full has-text-right"
                   style="width:150px"
                   v-model="value.point"
                   @input="e => setNumber(e, 'point')"
                   :disabled="!value.is_cancel_point"
                   :min="0"
                   type="number">
            <span style="margin:auto 4px;font-size:0.9rem">원</span>
          </div>
        </div>
        <div v-if="totalCancelPoint>0" style="margin-top:4px">기존 취소 적립금: {{ totalCancelPoint | currency }}</div>
        <div class="flex-align" style="margin-top:8px" v-if="userCouponList.length>0">
          <admin-form-item label="쿠폰 적용 취소">
            <lp-check-group :list="userCouponList"
                            :data="value.cancel_coupons"
                            value_name="value"
                            label_name="label"
                            style="margin-bottom:12px"></lp-check-group>
          </admin-form-item>
        </div>
      </admin-form-item>-->
    </div>

    <div class="column is-full" v-show="vBtn">
      <div class="flex justify-center">
        <button class="button is-light" @click="$emit('close')">취소</button>
        <button class="button is-primary" style="margin-left:6px;" @click="saveData">저장하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpCheckGroup from "../../../module/common/LpCheckGroup";

  export default {
    components: {
      LpCheckGroup,
      LpCheckBool,
      LpRadio,
      AdminFormItem},
    name: "order-refund",
    props: {
      order: {
        type: Object,
        required: true
      },
      order_product_list: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        vBtn: false,
        is_modify: false,
        value: {
          refund_delivery_cost: 0,  // 환불할 배송비
          is_first_dp_refund: false, // 초기 배달비 환불 여부
          dp_type: 0, // 반품 배달비 종류 ( 0: 선불 1: 환불금액에서 차감 2: 착불 )
          substraction_price: 0, // 환불 금액에서 차감할 금액
          refund_type: 0, // 환불 종류(0: 전액, 1: 부분)
          refund_price: 0,  // 환불 금액
          refund_method: 0,  // 환불 방법(0: 현금, 1: 카드취소)
          // 환불 받을 계좌
          refund_info: {
            account: '',
            name: '',
            bank: ''
          },
          is_cancel_point: false,
          is_cancel_coupon: false,
          point: 0,
          coupon_price: 0,
          refund_all_price: 0,
          refund_part_price: 0,
          cancel_coupons: []
        },
        bankArr: [],
        // 선택된 주문 상품 (반품 검사중 상태)
        order_product: [],
        // 환불 정보
        refundInfo: []
      }
    },
    created () {
      this.getBankList();
      this.init();
    },
    watch: {
      'value.is_first_dp_refund'(n) {
        if(n===true) {
          this.value.refund_delivery_cost = this.order.delivery_cost;
        } else {
          this.value.refund_delivery_cost = 0;
        }
      },
      // 환불 종류
      'value.refund_type'(n) {
        if(n===0) {
          this.value.refund_all_price = this.calcRefundTotalProductPrice;
          this.value.refund_part_price = 0;
        }
      },
      // 반품 배달비 종류
      'value.dp_type'(n) {
        if(n!==1) this.value.substraction_price = 0;
      },
      // 포인트 차감 사용여부
      'value.is_cancel_point'(n) {
        if(!n) this.value.point = 0;
      },
      // 쿠폰 차감 사용여부
      'value.is_cancel_coupon'(n) {
        if(!n) this.value.coupon_price = 0;
      }
    },
    computed: {
      // 배송비 환불 여부
      isDeliveryCostRefund() {
        let exist = false;
        this.refundInfo.forEach(item => {
          if(item.refund_delivery_cost && item.refund_delivery_cost>0) {
            exist = true;
          }
        })
        return exist;
      },
      // 주문에서의 환불 정보들 중 배송비 환불 금액 가져오기
      refundDeliveryCost() {
        let price = 0;
        this.refundInfo.forEach(item => {
          if(item.refund_delivery_cost && item.refund_delivery_cost>0) {
            price += item.refund_delivery_cost;
          }
        })
        return price;
      },
      deliveryPriceInfo() {
        let text = '';
        let dp_setting = this.order_product[0].delivery_price.delivery_price_setting
        for(let i=0; i<dp_setting.length; i++) {
          let item = dp_setting[i];
          if (i === dp_setting.length - 1) text += `${this.currency(item.min)} 이상, ${item.price===0?'무료':item.price}`;
          else text += `${this.currency(item.min)} ~ ${this.currency(item.max)} 일때, ${item.price}원\n`;
        }
        return text;
      },
      // 배송비 차감 여부
      /*isFirstDeliveryPriceRefund() {
        let enable = true;
        if(this.refundInfo.length>0) {
          let is_first_dp_refund = this.refundInfo.some(item=> {
            return item.is_first_dp_refund;
          })
          if(is_first_dp_refund) enable = false;
        }
        return enable;
      },*/
      // 사용한 쿠폰 목록
      userCouponList() {
        let list = [];
        if(this.order) {
          let user_coupon = this.order.user_coupon_data;
          if(user_coupon && !user_coupon.enable_use) {
            list.push({label: user_coupon.name, value: user_coupon.id})
          }
        }
        if(this.order_product) {
          this.order_product.forEach(item => {
            let user_coupon = item.user_coupon_data;
            if(user_coupon && !user_coupon.enable_use) {
              list.push({label: user_coupon.coupon.name, value: user_coupon.id});
            }
          })
        }
        return list;
      },
      totalCancelPoint() {
        let total = 0;
        if(this.refundInfo.length>0) {
          if(this.refundInfo) {
            this.refundInfo.forEach(item => {
              total += item.point;
            })
          }
        }
        return total;
      },
      // 주문 상품 총 가격
      calcTotalProductPrice() {
        let price = 0;
        this.order_product.forEach(item => {
          price += (item.product_price * item.quantity) - item.discount_price;
        })
        return price;
      },
      // 남은 환불 가능한 금액
      calcRefundTotalProductPrice () {
        let price = 0;
        // 남은 환불 가능한 금액 = 결제금액 - 취소금액
        let remain_price = this.order.total_price - this.order.cancel_price;
        // price 상품 총 금액
        this.order_product.forEach(item => {
          price += (item.product_price * item.quantity) - item.discount_price;
        })
        if(this.value.refund_type===0 && this.isLastRefund) {
          // 전액 환불일때
          price -= this.order.point;
          price -= this.order.coupon_price;
        }
        if(remain_price < price) {
          return remain_price;
        }
        return price;
      },
      // 환불 방법 목록
      refundMethodArr () {
        let arr = [{label:'현금 환불 (입금)',value:0}];
        if(this.order.pay_type!==2 && this.order.pay_type!==4) {
          arr.push({label:'카드 취소', value:1});
        }
        return arr
      },
      isLastRefund() {
        let cancel_op_count = 0;
        this.refundInfo.forEach(refund=> {
          cancel_op_count += refund.order_product.length;
        })
        return this.order.order_product.length-cancel_op_count === this.order_product.length
      },
      // 환불 총 합계
      calcTotalRefundPrice () {
        let total = this.calcRefundProductPrice;

        // 초기 배달비 환불 체크했을 경우
        if(this.value.is_first_dp_refund) total += this.value.refund_delivery_cost;

        // 마지막 환불시 실행
        if(this.isLastRefund) {
          // 환불할 금액 + 환불된 금액 > 결제금액
          // if(total + this.order.cancel_price > this.order.total_price) {
          //   total -= this.order.point;
          //   total -= this.order.coupon_price;
          // }
          // if(this.value.refund_type===0) {
          //   // 전액 환불일때
          //   total -= this.order.point;
          //   total -= this.order.coupon_price;
          // }
          // else if(this.value.refund_type===1) {
          //   // 부분 환불일때
          //   if(total>this.order.point + this.order.coupon_price) {
          //     total -= this.order.point;
          //     total -= this.order.coupon_price;
          //   }
          // }

        }

        return total
      },
      // 환불 종류에 따른 환불 금액
      calcRefundProductPrice () {
        // 0: 전액 환불, 1: 부분 환불
        if(this.value.refund_type===0 && this.isLastRefund) {
          return this.calcRefundTotalProductPrice;
        }
        else if(this.value.refund_type===0) {
          return this.value.refund_all_price;
        }
        else {
          return this.value.refund_part_price;
        }
      }
    },
    methods: {
      async init () {
        let order_product = this.cloneItem(this.order_product_list);
        this.order_product = order_product.filter(item => {
          return item.status>=500 && item.status<=501;
          // return item.status===702 || item.status===703;
        })
        // 전액 환불일 경우
        if(this.value.refund_type===0) {
          this.value.refund_all_price = this.calcRefundTotalProductPrice;
        }

        // this.value.is_first_dp_refund = false;
        // this.value.is_cancel_coupon = true;
        // this.value.is_cancel_point = true;
        // this.value.point = this.order.point;
        // this.value.coupon_price = this.order.coupon_price;

        if(this.order.refund.length>0) {
          for(let refund_id of this.order.refund) {
            try {
              let res = await this.$axios.get(this.getUrl(`mart/order/${this.$route.query.id}/refund/${refund_id}`));
              this.refundInfo.push(res.data);

            } catch(error) {

            }
          }
        }
        this.vBtn = true;
      },
      setQauntity(e, op) {
        op.quantity = parseInt(e.target.value.substr(0, 2));
      },
      setNumber (e, depth) {
        let price = parseInt(e.target.value);
        if(price > this.order[depth]) {
          this.value[depth] = this.order[depth];
        }
        else {
          this.value[depth] = price;
        }


      },
      // 반품 배달비에서 차감 금액
      inputSubstractionPrice (res) {
        console.log(res)
        let price = 0;
        if (res.text === '' || res.text === 0) price = 0;
        else price = parseInt(res.text)
        // 환불 금액에서 차감
        if(res.value===1) {
          if(this.calcTotalRefundPrice>0) {
            this.value.substraction_price = price;
          }
        }
      },
      // 반품 배달비 금액
      inputRefundPrice (res) {
        let price = 0;
        if (res.text === '' || res.text === 0) price = 0;
        else price = parseInt(res.text)
        // 전액 환불
        if(res.value===0) {
          this.value.refund_all_price = this.calcRefundTotalProductPrice;
        }
        // 부분 환불
        else if(res.value===1) {
          if(price > this.calcRefundTotalProductPrice) {
            this.value.refund_part_price = this.calcRefundTotalProductPrice;
          }
          else this.value.refund_part_price = price;
        }
      },
      saveData () {
        let value = this.cloneItem(this.value);
        /*if(this.order.point - this.totalCancelPoint < this.value.point) {
          this.toast('취소 적립금은 기존 취소 적립금과 합하여 \n 기존 사용된 적립금을 넘을 수 없습니다.');
          return;
        }*/
        // 현금 환불일 경우 체크
        if(value.refund_method===0) {
          if(value.refund_info.account_num==='' || value.refund_info.bank==='' ||
            value.refund_info.name==='') {
            this.toast('계좌 정보를 입력해주세요.');
            return;
          }
        }
        if(this.calcTotalRefundPrice<0) {
          this.toast('환불할 금액을 0원이상 설정하세요.');
          return
        }
        /*if(value.refund_price>this.calcRefundTotalProductPrice) {
          this.toast('환불할 금액을 총 결제 금액보다 낮게 입력하세요.');
          return
        }*/
        if(this.calcTotalRefundPrice > this.order.total_price) {
          this.toast('취소 금액을 결제 금액보다 낮게 입력하세요.');
          return;
        }
        value.refund_price = this.calcTotalRefundPrice;
        let id_list = [];
        this.order_product.forEach(item => {
          id_list.push(item.id)
        })
        value.order_product = id_list;
        if(this.is_modify) {
          this.$axios.patch(this.getUrl(`mart/order/${this.order.id}/refund/${this.value.id}`), value).then(res => {
            if(res.status===200) {
              this.toast('저장되었습니다')
              this.$emit('confirm')
            }
          }).catch(error => {
            if(error.response){
              this.toast(error.response.data.message);
            }
          });
        }
        else {
          this.$axios.post(this.getUrl(`mart/order/${this.order.id}/refund`), value).then(res => {
            if(res.status===200) {
              this.toast('저장되었습니다')
              this.$emit('confirm')
            }
          }).catch(error => {
            if(error.response){
              this.toast(error.response.data.message);
            }
          });
        }
      },
      getBankList() {
        this.$axios.get('public/banks').then(res=>{
          this.bankArr = res.data;
        })
      },
      // getDeliveryCost() {
      //   // 해당 기준 배송비 - 앞서 차감한 배송비
      //   this.calcDeliveryCost = this.getDeliveryCostFromDeliveryPrice() - this.refundDeliveryCost;
      // },
      // getDeliveryCostFromDeliveryPrice() {
      //   let delivery_cost = 0;
      //   let op = this.order_product[0];
      //   let dp_setting = op.delivery_price.delivery_price_setting;
      //   // 전체 상품 금액 - 환불한 금액 = 남은 결제금액
      //   let remain_price = this.order.total_price - this.order.cancel_price;
      //   // 배송비 유형이 금액별일 경우
      //   if (op.delivery_price.delivery_type === 2) {
      //     let data = undefined;
      //     for(let item of dp_setting) {
      //       if(item.min <= remain_price && item.max >= total_price) {
      //         data = item;
      //         break;
      //       }
      //     }
      //     if (data) {
      //       delivery_cost = data.price;
      //     }
      //   }
      //   return delivery_cost;
      // }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
    .delivery-order-info
      width 100%

    .delivery-orderproduct-table th
      background-color #eee

    .delivery-orderproduct-table th
    .delivery-orderproduct-table td
    .delivery-order-info td
      text-align center !important
      border 1px solid #e0d9d9
      border-bottom-width thin !important
      padding 6px
      vertical-align middle !important

    .delivery-orderproduct-table .table-result
      background-color #EBEAE4

    .delivery-order-info .order-info-title
      background-color #eee
  .product-price-refund-st
    text-decoration line-through
</style>
